module.exports = __webpack_public_path__ + "img/z2.e53ace42.png";